import { Collapse } from "antd";
import styled from "styled-components";

export const StyledNestedAccordion = styled(Collapse)<{
    $level: number;
    $isLast: boolean;
}>`
    width: 100%;
    border: none;
    display: flex;
    flex-direction: column;
    gap: 16px;
    border-radius: 10px;

    .ant-collapse-item {
        border-bottom: 1px solid ${({ theme }) => theme.secondaryBorderColor};
    }

    .ant-collapse-header {
        padding: 0 16px ${({ $level = 1 }) => 16 - $level * 2}px
            ${({ $isLast }) => ($isLast ? "0px" : "16px")} !important;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .ant-collapse-content {
        border-color: ${({ theme }) => theme.secondaryBorderColor};
    }

    .ant-collapse-content-box {
        padding: 12px 0px 12px ${({ $isLast }) => ($isLast ? "0px" : "16px")} !important;
        background-color: transparent !important;
    }

    max-width: ${({ $level = 1 }) => 100 - $level * 2}%;
    margin-left: ${({ $level = 1 }) => ($level > 1 ? "auto" : "0")};
`;
